import { Grid, Typography } from '@material-ui/core'
import i18n from 'i18next'
import { FC } from 'react'

interface Props {
  t: i18n.TFunction
}

const NotAvailable: FC<Props> = ({ t }) => {
  return (
    <Grid container alignItems='center' justify='center'>
      <Typography variant='h5' style={{ marginTop: '3rem', marginLeft: '1.5rem', marginRight: '1.5rem' }}>
        {t('showings.reserve.notInterestedOrRejected')}
      </Typography>
    </Grid>
  )
}

export default NotAvailable
